import React from 'react'
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { DashboardRoutes } from './DashboardRoutes';
import RutasPrivadas from './RutasPrivadas';


export const AppRouter = ({stateSesion, setStateSesion}) => {

	if(localStorage.getItem('logueado') === null)
    {
        localStorage.setItem('logueado', 'false');
    }
    if(localStorage.getItem('usuario') === null)
    {
        localStorage.setItem('usuario', '');
	}

    return (
		<Router>
			<div>
				<Switch>
					{/* <Route exact path="/Login" component={(props) => (<Login {...props} stateSesion={stateSesion} setStateSesion={setStateSesion} />)} /> */}
					<RutasPrivadas path="/" component={DashboardRoutes} stateSesion={stateSesion} setStateSesion={setStateSesion}  />
				</Switch>
			</div>
		</Router>
    )
}
